import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { createRecord, findRecord, clearState } from '~/store/modules/animals';
import AnimalRecord from '~/records/AnimalRecord';
import { animalsRoute } from '~/routes'

import CrudNew from '~/containers/CrudNew';

import FormFields from './components/FormFields';

export default function New() {
  const { id } = useParams();
  const [record, setRecord] = useState(new AnimalRecord());
  const dispatch = useDispatch();
  const { isLoading, current, errors } = useSelector(state => state.animals);

  useEffect(() => {
    if(id){
      dispatch( findRecord(id, {include: 'farm'}) );
    }
    return () => {
      dispatch( clearState() )
    };
  }, [])

  useEffect(() => {
    if(current && id){
      setRecord( record.updateAttributes(current) )
    }
  }, [current])

  const onSubmit = useCallback( () => {
    const data = record.toParams();
    dispatch( createRecord(data) );
  }, [record]);

  const handleChange = useCallback(attrs => {
    setRecord(record.updateAttributes(attrs));
  }, [record, setRecord]);

  const clearAfterSaved = useCallback(() => {
    setRecord( new AnimalRecord() )
  }, [setRecord]);

  return (
    <CrudNew
      clearAfterSaved={clearAfterSaved}
      onSubmit={onSubmit}
      errors={{ errors }}
      breadcrumbs={[
        { path: animalsRoute.list.path, text: 'Animais' },
        { text: 'Cadastrando Animal' },
      ]}
      footerActionsProps={{isLoading}}
    >
      <FormFields
        record={record}
        onChange={handleChange}
      />
    </CrudNew>
  );
}